<template>
  <div>
    <div class="input-group" @click="display_color_picker=true">
      <div class="input-group-prepend" style="">
        <div class="input-group-text" style="background: #e4e5e6;" :style="{ background: color}">
        </div>
      </div>
      <input type="text" placeholder="ระบุสี" class="form-control" v-model="color" disabled>
    </div>
    <photoshop-picker v-if="display_color_picker" class="color-picker" :value="color" @input="updateThemeColor" @ok="ok" @cancel="cancel"/>
  </div>
</template>

<script>
import { Photoshop } from 'vue-color'

export default {
  name: 'colorPicker',
  props: ['value', 'hasAlpha'],
  components: { 'photoshop-picker': Photoshop },
  data() {
    return {
      selected_theme_color:'',
      display_color_picker: false,
      color: this.value
    }
  },
  methods: {
    updateThemeColor(obj) {
      if(obj){
        if (!this.hasAlpha && obj.hex){
          this.selected_theme_color = obj.hex
        } else if(this.hasAlpha&&obj.rgba){
          this.selected_theme_color = `rgba(${obj.rgba.r}, ${obj.rgba.g}, ${obj.rgba.b}, 0.5)`
        }
      }
    },
    ok() {
      if(this.selected_theme_color&&this.color){
        this.color = this.selected_theme_color
        this.display_color_picker = false
        this.$emit('input', this.color)
      }else{
        this.cancel()
      }
    },
    cancel() {
      this.display_color_picker = false
    }
  }
}
</script>
